/**
 * Generated from ch6_p13.fla
 */
export function ch6_p13(this: Ich6_p13) {
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2.call(rain[0] as Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 384;
		rain[0].width = 1641.00;
		rain[0].height = 768.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1.call(rain[1] as Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 388.5;
		rain[1].width = 1600.50;
		rain[1].height = 759.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const sparkles = this.sparkles;
	if (!sparkles[0] && sparkles.elementFactory) {
		sparkles[0] = sparkles.elementFactory(0,undefined);
	}
	if (sparkles[0]) {
		ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349.call(sparkles[0] as Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349);
		sparkles[0].x = 835.25;
		sparkles[0].y = 589.75;
		sparkles[0].width = 1447.50;
		sparkles[0].height = 313.50;
		sparkles[0].alpha = 1;
		if (sparkles[0].onLayout) sparkles[0].onLayout();
	}
	if (!sparkles[1] && sparkles.elementFactory) {
		sparkles[1] = sparkles.elementFactory(1,undefined);
	}
	if (sparkles[1]) {
		ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350.call(sparkles[1] as Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350);
		sparkles[1].x = 826.75;
		sparkles[1].y = 587;
		sparkles[1].width = 1443.50;
		sparkles[1].height = 323.00;
		sparkles[1].alpha = 1;
		if (sparkles[1].onLayout) sparkles[1].onLayout();
	}
	if (!sparkles[2] && sparkles.elementFactory) {
		sparkles[2] = sparkles.elementFactory(2,undefined);
	}
	if (sparkles[2]) {
		ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy.call(sparkles[2] as Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy);
		sparkles[2].x = 836;
		sparkles[2].y = 590;
		sparkles[2].width = 1434.00;
		sparkles[2].height = 301.00;
		sparkles[2].alpha = 1;
		if (sparkles[2].onLayout) sparkles[2].onLayout();
	}
	const bg = this.bg;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_horse.call(this.horse);
	horse.x = 575.25;
	horse.y = 768;
	horse.width = 581.50;
	horse.height = 643.50;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const tylerHolly = this.tylerHolly;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_tylerholly.call(this.tylerHolly);
	tylerHolly.x = 998;
	tylerHolly.y = 768;
	tylerHolly.width = 490.00;
	tylerHolly.height = 652.50;
	tylerHolly.alpha = 1.00;
	if (tylerHolly.onLayout) tylerHolly.onLayout();
	const frameRight = this.frameRight;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeRframe.call(this.frameRight);
	frameRight.x = 1663.5;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframerline.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 597;
	linesRight.width = 92.00;
	linesRight.height = 322.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframelline.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 661.25;
	linesLeft.width = 126.00;
	linesLeft.height = 213.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_bg(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p13_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_horse(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p13_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_tylerholly(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_tylerholly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p13_tylerholly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer349", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer350", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer349copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeRframe(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframerline(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframerline) {
	if (this.setLayoutTexture) this.setLayoutTexture("rline", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeLframe(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframelline(this: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframelline) {
	if (this.setLayoutTexture) this.setLayoutTexture("lline", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p13Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p13Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p13Sprite extends Ich6_p13Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p13Text extends Ich6_p13Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p13Polygon extends Array<number> {
}
interface Ich6_p13 {
	readonly rain: Ich6_p13Array<Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2|Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1>;
	readonly sparkles: Ich6_p13Array<Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349|Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350|Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy>;
	readonly bg: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_bg;
	readonly horse: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_horse;
	readonly tylerHolly: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_tylerholly;
	readonly frameRight: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeRframe;
	readonly linesRight: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframerline;
	readonly frameLeft: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeLframe;
	readonly linesLeft: Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframelline;
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_bg extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_horse extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_tylerholly extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain2 extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetrainoverlayrain1 extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349 extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer350 extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_sparklesLayer349copy extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeRframe extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframerline extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframeLframe extends Ich6_p13Sprite {
}
interface Ich6_p13_hh_ch6_72dpi_p013psdAssetchp6_p13_wcframelline extends Ich6_p13Sprite {
}
